import React, { FC } from 'react';
import Lottie from 'react-lottie-wrapper';

import animationData from '@lmt/unicorn-shared/app/animations/load-doc.json';
import styles from './DocumentLoader.module.scss';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const DocumentLoader: FC = () => {
  return (
    <div className={styles.animation}>
      <Lottie options={defaultOptions} height={15} width={15} />
    </div>
  );
};
